"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.GnosisSafeProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_singleton",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060405161019838038061019883398101604081905261002f916100b9565b6001600160a01b0381166100945760405162461bcd60e51b815260206004820152602260248201527f496e76616c69642073696e676c65746f6e20616464726573732070726f766964604482015261195960f21b606482015260840160405180910390fd5b600080546001600160a01b0319166001600160a01b03929092169190911790556100e9565b6000602082840312156100cb57600080fd5b81516001600160a01b03811681146100e257600080fd5b9392505050565b60a1806100f76000396000f3fe6080604052600073ffffffffffffffffffffffffffffffffffffffff8154167fa619486e00000000000000000000000000000000000000000000000000000000823503604d57808252602082f35b3682833781823684845af490503d82833e806066573d82fd5b503d81f3fea26469706673582212202250dd8b187c3976314786b7353545d8143eb61378dfa480c9cadc1a656ecce264736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var GnosisSafeProxy__factory = /** @class */ (function (_super) {
    __extends(GnosisSafeProxy__factory, _super);
    function GnosisSafeProxy__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    GnosisSafeProxy__factory.prototype.deploy = function (_singleton, overrides) {
        return _super.prototype.deploy.call(this, _singleton, overrides || {});
    };
    GnosisSafeProxy__factory.prototype.getDeployTransaction = function (_singleton, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _singleton, overrides || {});
    };
    GnosisSafeProxy__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    GnosisSafeProxy__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    GnosisSafeProxy__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    GnosisSafeProxy__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    GnosisSafeProxy__factory.bytecode = _bytecode;
    GnosisSafeProxy__factory.abi = _abi;
    return GnosisSafeProxy__factory;
}(ethers_1.ContractFactory));
exports.GnosisSafeProxy__factory = GnosisSafeProxy__factory;
